import { PostLiteraturePdfEmailApiParameter, sendLiteraturePdfEmail } from "@dana/Overrides/Services/EmailService";
import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    HasOnError,
    HasOnSuccess,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";

type PostLiteraturePdfEmailParameter = {
    recipientEmailAddress?: string;
    productId?: string;
    documentId?: string;
    pdfUrl?: string;
    pdfName?: string;    
    productTitle?:string;
    productNumber?:string;
    productBrand?:string;
    productUrl?:string;  
}& HasOnSuccess<any> & HasOnError;

type HandlerType = ApiHandlerDiscreteParameter<PostLiteraturePdfEmailParameter, PostLiteraturePdfEmailApiParameter>;

export const SendDataToApi: HandlerType = async props => {
   await sendLiteraturePdfEmail({
        recipientEmailAddress:props.parameter.recipientEmailAddress,  
        productId: props.parameter.productId,
        documentId: props.parameter.documentId,
        pdfUrl: props.parameter.pdfUrl,
        pdfName: props.parameter.pdfName,
        productTitle:props.parameter.productTitle,
        productNumber:props.parameter.productNumber,
        productBrand:props.parameter.productBrand,
        productUrl:props.parameter.productUrl,
    });
    props.parameter.onSuccess?.(props.apiResult);
};

export const chain = [SendDataToApi];

const PostLiteraturePdfEmailHandler = createHandlerChainRunner(chain, "PostLiteraturePdfEmailHandler");
export default PostLiteraturePdfEmailHandler;